import { cssVar, setCssVar } from '@helpers/cssVar';
import global from '@helpers/global';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const Container = styled.div `
  ${setCssVar('sitePadding', `${global.siteWidePaddingMobile}px`)};
  ${setCssVar('siteWidth', '100%')};

  margin-left: auto;
  margin-right: auto;
  max-width: calc(${cssVar('siteWidth')} + (${cssVar('sitePadding')} * 2));
  padding-left: ${cssVar('sitePadding')};
  padding-right: ${cssVar('sitePadding')};
  width: 100%;

  @media ${from(Device.MobileLarge)} {
    ${setCssVar('sitePadding', `${global.siteWidePaddingTablet}px`)};
  }

  @media ${from(Device.TabletLarge)} {
    ${setCssVar('sitePadding', `${global.siteWidePadding}px`)};
  }

  ${({ width }) => {
    switch (width) {
        case 'default':
            return css `
          @media ${from(Device.DesktopLarge)} {
            ${setCssVar('siteWidth', `${global.siteWideWidth}px`)};
          }
        `;
        case 'narrow':
            return css `
          @media ${from(Device.DesktopSmall)} {
            ${setCssVar('siteWidth', `${global.siteWideWidthNarrow}px`)};
          }
        `;
        case 'inner':
            return css `
          @media ${from(Device.Tablet)} {
            ${setCssVar('siteWidth', `${global.siteWideWidthInner}px`)};
          }
        `;
    }
}}
`;
export default {
    Container,
};
